import { getBankOptionsForCurrency } from "@/modules/dashboard/confirmations/constants/paymentMethodsByCurrency.config";
import { getPaymentMethodFields } from "@/modules/dashboard/payments/constants/paymentMethodFields.config";
import { COUNTRY_CODE_TO_CURRENCY } from "./public-accounts.constants";
import type { PaymentMethodFieldConfig } from "@/modules/dashboard/payments/types/new-payment.types";

export type BankOption = { label: string; value: string };

export function getBankOptionsForCountry(countryCode: string): BankOption[] {
  if (!countryCode?.trim()) return [];
  const currency = COUNTRY_CODE_TO_CURRENCY[countryCode.trim()];
  if (!currency) return [];
  return getBankOptionsForCurrency(currency) as BankOption[];
}

export function getPaymentMethodFieldsForAccount(
  countryCode: string,
  method: string
): PaymentMethodFieldConfig[] {
  if (!countryCode?.trim() || !method?.trim()) return [];
  const currency = COUNTRY_CODE_TO_CURRENCY[countryCode.trim()];
  if (!currency) return [];
  return getPaymentMethodFields(currency, method.trim());
}
